/**
 * Kit Cart Guard v4 — keeps the Complete Kit and its chasen line together.
 * Removing either one removes both; quantities stay matched; neither can
 * sit in the cart without the other.
 *
 * v3: also watches XMLHttpRequest (not just fetch), since this theme's
 * jQuery-driven cart AJAX (add/remove/quantity change) goes through XHR,
 * not fetch — v2 only caught fetch-based cart changes and missed these,
 * which let an orphaned kit-component chasen stay in the cart after its
 * kit line was removed via the theme's own remove/quantity controls.
 *
 * v4: removal now works both directions — removing just the chasen line
 * also removes its kit line (previously only kit-removal cascaded to the
 * chasen, not the reverse).
 */
(function () {
  var running = false;

  function reconcile() {
    if (running) return;
    running = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var groups = {};
        cart.items.forEach(function (item) {
          var kitId = item.properties && item.properties._kit_id;
          if (!kitId) return;
          groups[kitId] = groups[kitId] || { kit: null, component: null };
          if (item.properties._kit_component) {
            groups[kitId].component = item;
          } else {
            groups[kitId].kit = item;
          }
        });

        var updates = {};
        Object.keys(groups).forEach(function (kitId) {
          var g = groups[kitId];
          if (g.component && !g.kit) {
            updates[g.component.key] = 0; // orphaned whisk -> remove
          } else if (g.kit && !g.component) {
            updates[g.kit.key] = 0; // kit without its chasen -> remove kit too
          } else if (g.kit && g.component && g.component.quantity !== g.kit.quantity) {
            updates[g.component.key] = g.kit.quantity; // match quantities
          }
        });

        var keys = Object.keys(updates);
        if (!keys.length) { running = false; return; }

        var chain = Promise.resolve();
        keys.forEach(function (key) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: updates[key] })
            });
          });
        });
        return chain.then(function () {
          running = false;
          // On the cart page, reload so the customer sees the corrected cart.
          if (window.location.pathname.indexOf('/cart') === 0) {
            window.location.reload();
          } else {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
          }
        });
      })
      .catch(function () { running = false; });
  }

  document.addEventListener('DOMContentLoaded', reconcile);
  ['cart:updated', 'cart:change', 'cart:refresh', 'variant:add'].forEach(function (evt) {
    document.documentElement.addEventListener(evt, function () {
      setTimeout(reconcile, 400);
    });
  });

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(reconcile, 400); });
    }
    return p;
  };

  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._kitGuardUrl = url;
    return origXHROpen.apply(this, arguments);
  };

  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var url = this._kitGuardUrl;
    if (typeof url === 'string' && /\/cart\/(change|update|clear)/.test(url)) {
      this.addEventListener('loadend', function () {
        setTimeout(reconcile, 400);
      });
    }
    return origXHRSend.apply(this, arguments);
  };
})();
